import { ReactNode } from 'react';

interface Props {
  icon?: ReactNode;
  label: ReactNode;
  isActive: boolean;
  isDisabled?: boolean;
  onClick: () => void;
}

/** Pill-shaped filter toggle. Shared by the gear filters and the leaderboard. */
export const Chip = ({ icon, label, isActive, isDisabled = false, onClick }: Props) => {
  const borderClass = isDisabled
    ? 'border-dashed border-zinc-700'
    : isActive
      ? 'border-white'
      : 'border-zinc-700';
  const textClass = isActive ? 'text-white' : 'text-zinc-400';
  const opacityClass = isDisabled ? 'opacity-50' : '';
  const cursorClass = isDisabled ? 'cursor-not-allowed' : 'cursor-pointer';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      aria-pressed={isActive}
      className={`shrink-0 flex flex-row items-center gap-2 px-4 py-2 text-sm rounded-full border transition-colors focus:outline-none ${borderClass} ${textClass} ${opacityClass} ${cursorClass}`}
    >
      {icon}
      <span className="whitespace-nowrap">{label}</span>
    </button>
  );
};
